import { c as _c } from "react/compiler-runtime";
import { ProjectTabs, QueryParams, TeamTabs } from "@router/route-params";
import { generateAccountSettingsRoute, generateCreditsRoute, generateGroupDetailsRoute, generateGroupsRoute, generateMemberProfileRoute, generateMembersRoute, generateProjectDetailsRoute, generateProjectsRoute, generateSettingRoute, generateSubscriptionExpiredRoute, generateTeamDetailsRoute, getPreservedQueryParams } from "@router/router-helper";
import { getDataManagementUrl, OPEN_PROJECT_TARGET_ATTRIBUTE } from "@utils/project-utils";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

/** A hook that gathers all the navigation and routing in the app */
export function useAppNavigation() {
  const $ = _c(55);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  let t0;
  if ($[0] !== location || $[1] !== navigate) {
    t0 = function navigateWithPreservedParams(t1) {
      const {
        path,
        state: t2,
        shouldReplace: t3,
        extraQueryParams: t4
      } = t1;
      const state = t2 === undefined ? "in-app-navigation" : t2;
      const shouldReplace = t3 === undefined ? false : t3;
      const extraQueryParams = t4 === undefined ? [] : t4;
      const search = new URLSearchParams(getPreservedQueryParams(location.search));
      extraQueryParams.forEach(t5 => {
        const [key, value] = t5;
        return search.append(key, value);
      });
      const searchString = search.toString();
      const cleanedPath = path.split("?")[0];
      navigate({
        pathname: cleanedPath,
        search: searchString ? `?${searchString}` : ""
      }, {
        state,
        replace: shouldReplace
      });
    };
    $[0] = location;
    $[1] = navigate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const navigateWithPreservedParams = t0;
  let t1;
  if ($[3] !== navigateWithPreservedParams) {
    t1 = function navigateToRoot() {
      navigateWithPreservedParams({
        path: "/"
      });
    };
    $[3] = navigateWithPreservedParams;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const navigateToRoot = t1;
  let t2;
  if ($[5] !== navigateWithPreservedParams) {
    t2 = function navigateToProjects(t3) {
      const {
        companyId,
        projectStatus
      } = t3;
      const path_0 = generateProjectsRoute(companyId, projectStatus);
      navigateWithPreservedParams({
        path: path_0
      });
    };
    $[5] = navigateWithPreservedParams;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const navigateToProjects = t2;
  let t3;
  if ($[7] !== navigateWithPreservedParams) {
    t3 = function navigateToProjectDetail(t4) {
      const {
        companyId: companyId_0,
        projectId
      } = t4;
      const path_1 = generateProjectDetailsRoute(companyId_0, projectId);
      navigateWithPreservedParams({
        path: path_1
      });
    };
    $[7] = navigateWithPreservedParams;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const navigateToProjectDetail = t3;
  let t4;
  if ($[9] !== location || $[10] !== navigate) {
    t4 = function navigateToSnapshot(t5) {
      const {
        companyId: companyId_1,
        parentProjectId,
        snapshotId
      } = t5;
      const path_2 = generateProjectDetailsRoute(companyId_1, parentProjectId, ProjectTabs.snapshots);
      const preservedSearch = new URLSearchParams(getPreservedQueryParams(location.search));
      preservedSearch.set(QueryParams.snapshotId, snapshotId);
      navigate({
        pathname: path_2,
        search: preservedSearch.toString()
      }, {
        replace: true
      });
    };
    $[9] = location;
    $[10] = navigate;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const navigateToSnapshot = t4;
  let t5;
  if ($[12] !== navigateWithPreservedParams) {
    t5 = function navigateToGroups(t6) {
      const {
        companyId: companyId_2
      } = t6;
      const path_3 = generateGroupsRoute(companyId_2);
      navigateWithPreservedParams({
        path: path_3
      });
    };
    $[12] = navigateWithPreservedParams;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const navigateToGroups = t5;
  let t6;
  if ($[14] !== navigateWithPreservedParams) {
    t6 = function navigateToGroupDetails(t7) {
      const {
        companyId: companyId_3,
        groupId
      } = t7;
      const path_4 = generateGroupDetailsRoute(companyId_3, groupId);
      navigateWithPreservedParams({
        path: path_4
      });
    };
    $[14] = navigateWithPreservedParams;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const navigateToGroupDetails = t6;
  let t7;
  if ($[16] !== navigateWithPreservedParams) {
    t7 = function navigateToMembers(t8) {
      const {
        companyId: companyId_4,
        filters
      } = t8;
      const path_5 = generateMembersRoute(companyId_4);
      navigateWithPreservedParams({
        path: path_5,
        extraQueryParams: filters
      });
    };
    $[16] = navigateWithPreservedParams;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const navigateToMembers = t7;
  let t8;
  if ($[18] !== navigateWithPreservedParams) {
    t8 = function navigateToMemberProfile(t9) {
      const {
        companyId: companyId_5,
        memberId
      } = t9;
      const path_6 = generateMemberProfileRoute(companyId_5, memberId);
      navigateWithPreservedParams({
        path: path_6
      });
    };
    $[18] = navigateWithPreservedParams;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const navigateToMemberProfile = t8;
  let t9;
  if ($[20] !== navigateWithPreservedParams) {
    t9 = function navigateToTeamDetails(t10) {
      const {
        companyId: companyId_6,
        teamId
      } = t10;
      const path_7 = generateTeamDetailsRoute(companyId_6, teamId);
      navigateWithPreservedParams({
        path: path_7
      });
    };
    $[20] = navigateWithPreservedParams;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const navigateToTeamDetails = t9;
  let t10;
  if ($[22] !== navigateWithPreservedParams) {
    t10 = function navigateToTeamMembers(t11) {
      const {
        companyId: companyId_7,
        teamId: teamId_0
      } = t11;
      const path_8 = generateTeamDetailsRoute(companyId_7, teamId_0, TeamTabs.members);
      navigateWithPreservedParams({
        path: path_8
      });
    };
    $[22] = navigateWithPreservedParams;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const navigateToTeamMembers = t10;
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = function navigateToDataManagement(t12) {
      const {
        projectId: projectId_0,
        shouldEnableDev,
        shouldEnableAlpha,
        shouldEnableBeta,
        shouldShowUpload,
        shouldShowPublish
      } = t12;
      const path_9 = getDataManagementUrl({
        projectId: projectId_0,
        shouldEnableDev,
        shouldEnableAlpha,
        shouldEnableBeta,
        shouldShowUpload,
        shouldShowPublish
      }).href;
      window.open(path_9, OPEN_PROJECT_TARGET_ATTRIBUTE);
    };
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const navigateToDataManagement = t11;
  let t12;
  if ($[25] !== navigateWithPreservedParams) {
    t12 = function navigateToSettingsPage(t13) {
      const {
        companyId: companyId_8,
        settingsTab
      } = t13;
      const path_10 = generateSettingRoute(companyId_8, settingsTab);
      navigateWithPreservedParams({
        path: path_10
      });
    };
    $[25] = navigateWithPreservedParams;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const navigateToSettingsPage = t12;
  let t13;
  if ($[27] !== navigateWithPreservedParams) {
    t13 = function navigateToAccountSettingsPage(accountSettingsTab) {
      const path_11 = generateAccountSettingsRoute(accountSettingsTab);
      navigateWithPreservedParams({
        path: path_11,
        state: "in-app-navigation"
      });
    };
    $[27] = navigateWithPreservedParams;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const navigateToAccountSettingsPage = t13;
  let t14;
  if ($[29] !== navigateWithPreservedParams) {
    t14 = function navigateToCreditsPage(t15) {
      const {
        companyId: companyId_9
      } = t15;
      const path_12 = generateCreditsRoute(companyId_9);
      navigateWithPreservedParams({
        path: path_12,
        state: "in-app-navigation"
      });
    };
    $[29] = navigateWithPreservedParams;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const navigateToCreditsPage = t14;
  let t15;
  if ($[31] !== navigateWithPreservedParams) {
    t15 = function navigateToSubscriptionExpiredPage(t16) {
      const {
        companyId: companyId_10
      } = t16;
      const path_13 = generateSubscriptionExpiredRoute(companyId_10);
      navigateWithPreservedParams({
        path: path_13
      });
    };
    $[31] = navigateWithPreservedParams;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const navigateToSubscriptionExpiredPage = t15;
  let t16;
  if ($[33] !== searchParams || $[34] !== setSearchParams) {
    t16 = function setUrlParam(t17) {
      const {
        key: key_0,
        value: value_0
      } = t17;
      const newSearchParams = new URLSearchParams(searchParams.toString());
      if (value_0 === null) {
        newSearchParams.delete(key_0);
      } else {
        newSearchParams.set(key_0, value_0);
      }
      setSearchParams(newSearchParams);
    };
    $[33] = searchParams;
    $[34] = setSearchParams;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const setUrlParam = t16;
  let t17;
  if ($[36] !== location) {
    t17 = function getQueryParam(key_1) {
      const searchParams_0 = new URLSearchParams(location.search);
      return searchParams_0.get(key_1);
    };
    $[36] = location;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const getQueryParam = t17;
  let t18;
  if ($[38] !== getQueryParam || $[39] !== navigateToAccountSettingsPage || $[40] !== navigateToCreditsPage || $[41] !== navigateToGroupDetails || $[42] !== navigateToGroups || $[43] !== navigateToMemberProfile || $[44] !== navigateToMembers || $[45] !== navigateToProjectDetail || $[46] !== navigateToProjects || $[47] !== navigateToRoot || $[48] !== navigateToSettingsPage || $[49] !== navigateToSnapshot || $[50] !== navigateToSubscriptionExpiredPage || $[51] !== navigateToTeamDetails || $[52] !== navigateToTeamMembers || $[53] !== setUrlParam) {
    t18 = {
      navigateToRoot,
      navigateToProjects,
      navigateToProjectDetail,
      navigateToSnapshot,
      navigateToGroups,
      navigateToGroupDetails,
      navigateToMembers,
      navigateToMemberProfile,
      navigateToTeamDetails,
      navigateToTeamMembers,
      navigateToAccountSettingsPage,
      navigateToDataManagement,
      navigateToSettingsPage,
      navigateToCreditsPage,
      navigateToSubscriptionExpiredPage,
      setUrlParam,
      getQueryParam
    };
    $[38] = getQueryParam;
    $[39] = navigateToAccountSettingsPage;
    $[40] = navigateToCreditsPage;
    $[41] = navigateToGroupDetails;
    $[42] = navigateToGroups;
    $[43] = navigateToMemberProfile;
    $[44] = navigateToMembers;
    $[45] = navigateToProjectDetail;
    $[46] = navigateToProjects;
    $[47] = navigateToRoot;
    $[48] = navigateToSettingsPage;
    $[49] = navigateToSnapshot;
    $[50] = navigateToSubscriptionExpiredPage;
    $[51] = navigateToTeamDetails;
    $[52] = navigateToTeamMembers;
    $[53] = setUrlParam;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  return t18;
}